import React from 'react';
import { useDrop } from 'react-dnd';
import { FiChevronDown, FiChevronRight, FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';

const KpiGroup = ({ 
  groupName, 
  kpis, 
  isCollapsed, 
  onToggleCollapse, 
  onEditGroup, 
  onDeleteGroup, 
  onMoveKpiToGroup,
  onEditKpi,
  onDeleteKpi,
  DraggableKpiCard,
  moveKpi,
  saveKpiOrder,
  canDelete = true
}) => {
  const [{ isOver }, drop] = useDrop({
    accept: 'kpi',
    drop: (item) => {
      console.log('KpiGroup drop handler:', { item, groupName, targetGroup: groupName });
      // Move KPI to this group if it's from a different group
      if (item.kpiId && item.groupName !== groupName) {
        console.log('Moving KPI between groups:', item.kpiId, 'from', item.groupName, 'to', groupName);
        onMoveKpiToGroup(item.kpiId, groupName);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const handleToggleCollapse = () => {
    onToggleCollapse(groupName, !isCollapsed);
  };

  const handleEditGroup = () => {
    onEditGroup(groupName);
  };

  const handleDeleteGroup = () => {
    if (kpis.length > 0) {
      alert('Cannot delete group with KPIs. Move or remove KPIs first.');
      return;
    }
    
    if (window.confirm(`Are you sure you want to delete the group "${groupName}"?`)) {
      onDeleteGroup(groupName);
    }
  };

  return (
    <div 
      ref={drop}
      className={`kpi-group ${isOver ? 'drag-over' : ''}`}
    >
      {/* Group Header */}
      <div 
        className={`kpi-group-header ${isCollapsed ? 'collapsed' : ''}`}
        onClick={handleToggleCollapse}
      >
        <div className="kpi-group-title">
          {isCollapsed ? (
            <FiChevronRight size={16} className="kpi-group-chevron" />
          ) : (
            <FiChevronDown size={16} className="kpi-group-chevron" />
          )}
          <h3 style={{ margin: 0 }}>
            {groupName}
          </h3>
          <span className="kpi-group-count">
            {kpis.length} KPI{kpis.length !== 1 ? 's' : ''}
          </span>
        </div>
        
        <div 
          className="kpi-group-actions"
          onClick={(e) => e.stopPropagation()}
        >
          {groupName !== 'Default' && (
            <>
              <button
                onClick={handleEditGroup}
                className="kpi-group-action-btn"
                title="Edit Group Name"
              >
                <FiEdit2 size={12} />
              </button>
              {canDelete && kpis.length === 0 && (
                <button
                  onClick={handleDeleteGroup}
                  className="kpi-group-action-btn danger"
                  title="Delete Group"
                >
                  <FiTrash2 size={12} />
                </button>
              )}
            </>
          )}
        </div>
      </div>

      {/* Group Content */}
      {!isCollapsed && (
        <div className={`kpi-group-content ${kpis.length === 0 ? 'empty' : ''}`}>
          {kpis.length > 0 ? (
            <>
              <div className="dashboard-grid">
                {kpis.map((kpi, index) => (
                  <DraggableKpiCard 
                    key={kpi.kpiId} 
                    index={index}
                    kpi={kpi} 
                    moveKpi={moveKpi}
                    onEdit={onEditKpi}
                    onDelete={onDeleteKpi}
                    onDragEnd={saveKpiOrder}
                    groupName={groupName}
                  />
                ))}
              </div>
              {/* Drop zone indicator when dragging over */}
              {isOver && (
                <div className="kpi-group-drop-indicator">
                  Drop to move here
                </div>
              )}
            </>
          ) : (
            <div className={`kpi-group-empty-state ${isOver ? 'drag-over' : ''}`}>
              <FiPlus size={20} className="kpi-group-empty-icon" />
              <p className="kpi-group-empty-text">
                {isOver ? 'Drop KPI here' : 'Drag KPIs here or use the Add KPI button'}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default KpiGroup;
